module.exports = __webpack_public_path__ + "img/clippy.002c8173.png";